import { Token } from '../token';
import { TrackChangesNode } from './change-tracker-node';
import { AbstractConstructor, IKb3dModel, Kb3dModels } from './model-utils';

/** represents an instance of a class decorated by kb3dModel */
export interface IDecoratedModel {
    $type: keyof typeof Token;
    [key: string]: any;
}

export function Kb3dModel<T = any>(options: Partial<IKb3dModel<T>> & Pick<IKb3dModel<T>, 'token'>) {
    if (!('trackChanges' in options)) options.trackChanges = true; //if trackChanges was not provided, default to true

    const $type = options.token.key;

    return <C extends { new (...args: any[]): any }>(constructor: C) => {
        //set the $type on the prototype so we can always retrieve it from an instance
        Object.defineProperty(constructor.prototype, '$type', {
            enumerable: false,
            writable: true,
            value: $type,
        });

        /** we bundle up the track changes decorator here as well, as we want our map storing the constructors of
         * our models to actually be storing the constructor of the track changes proxy... so that when a class
         * is constructed using "create" that it will actually create the proxy class.
         */
        if (options.trackChanges) {
            const trackChangesFactory = TrackChangesNode(options);
            const combinedConstructor = trackChangesFactory(constructor);
            options.classConstructor = combinedConstructor;
        } else {
            options.classConstructor = constructor;
        }
        Kb3dModels.set(options.token, options as IKb3dModel<T>);
    };
}

export function BaseKb3dModel<T = any>(options: Partial<IKb3dModel<T>> & Pick<IKb3dModel<T>, 'token'>) {
    return <C extends AbstractConstructor<any>>(constructor: C) => {
        options.classConstructor = constructor;
        Kb3dModels.set(options.token, options as IKb3dModel<T>);
    };
}
